/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx, Text } from 'theme-ui'

import { CardStyled, CardIconStyled, CardTitleStyled, CardDescStyled, CardActionStyled } from './styles'
import LinkWrapper from './../../atoms/LinkWrapper'
import StaticImage from './../../atoms/ImageStatic'
import { CardProps } from './types'

const Card: React.FC<CardProps> = ({ image, title, desc, url, urlText, urlIsExternal }) => {
  return (
    <LinkWrapper {...{ url, urlIsExternal }}>
      <CardStyled>
        {image && (
          <CardIconStyled>
            <StaticImage {...{ image }} />
          </CardIconStyled>
        )}

        {title && (
          <CardTitleStyled>
            <Text
              as="p"
              sx={{
                variant: 'bodyRaleway4',
                fontFamily: 'secondary',
                textAlign: 'center',
                fontWeight: 'bold'
              }}
            >
              {title}
            </Text>
          </CardTitleStyled>
        )}
        {desc && (
          <CardDescStyled>
            <Text
              sx={{
                variant: 'bodyMontserrat4',
                fontFamily: 'primary',
                textAlign: 'center'
              }}
              as="p"
            >
              {desc}
            </Text>
          </CardDescStyled>
        )}
        {url && urlText ? (
          <CardActionStyled>
            <Text
              as="span"
              sx={{
                fontSize: ['10px', '12px'],
                lineHeight: 1
              }}
            >
              {urlText}
            </Text>
          </CardActionStyled>
        ) : (
          ''
        )}
      </CardStyled>
    </LinkWrapper>
  )
}

export default Card
